import React from 'react';
import Hero from './Home_banner';
import Organize from './Home_Organize';
import Event from './Home_Event';
import WhyChooseUs from './Home_Whychooseus';
import Statistics from './Home_Statistics';
import Clients from './Home_Client';
import OurWork from './Home_OurWork';
import Testimonials from './Home_Testinomials';
import SocialMediaFeed from './Home_SocialMediaFeed';

const Home = () => {
  return (
    <>
      <Hero/>
      <Organize />
      <Event />
      <WhyChooseUs />
      <Statistics />
      <Clients />
      <OurWork />
      <Testimonials />
      <SocialMediaFeed />
    </>
  )
}

export default Home
